import { DistrictType } from './district.constant';

export const FLIGHT_FILTERS = [
  {
    key: 'allFlights',
    text: 'All Flights',
    value: 'allFlights',
  },
  {
    key: 'futureFlights',
    text: 'Future Flights',
    value: 'futureFlights',
  },
  {
    key: 'last30DaysFlights',
    text: 'Last 30 Days Flights',
    value: 'last30DaysFlights',
  },
  {
    key: 'todaysFlights',
    text: "Today's Flights",
    value: 'todaysFlights',
  },
];

export const COMPANY_FILTER = [
  {
    key: 'all',
    text: 'SCG & Contractor',
    value: 'All',
  },
  {
    key: 'SCG',
    text: 'SCG',
    value: DistrictType.Company,
  },
  {
    key: 'contractor',
    text: DistrictType.Contractor,
    value: DistrictType.Contractor,
  },
];

export const YEAR_FILTER = [
  {
    key: 'all',
    text: 'All',
    value: 'All',
  },
  {
    key: '2021',
    text: '2021',
    value: '2021',
  },
  {
    key: '2020',
    text: '2020',
    value: '2020',
  },
  {
    key: '2019',
    text: '2019',
    value: '2019',
  },
  {
    key: '2018',
    text: '2018',
    value: '2018',
  },
  {
    key: '2017',
    text: '2017',
    value: '2017',
  },
  {
    key: '2016',
    text: '2016',
    value: '2016',
  },
];
